import React from 'react';

import { RELATIONSHIPS, RELATIONSHIPS_REVIEW } from 'config/formSections/relationships';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import * as formTypes from 'constants/formTypes';
import Show from 'components/Form/Show';
import { isPVQForm } from 'helpers/form';
import ConnectedMarital from '../RelationshipStatus/Marital';
import ConnectedCohabitants from '../RelationshipStatus/Cohabitants';
import People from '../People';
import Relatives from '../Relatives';

const sectionConfig = {
  section: RELATIONSHIPS.name,
  store: RELATIONSHIPS.store,
  subsection: RELATIONSHIPS_REVIEW.name,
};

const Review = function (props) {
  const subsectionProps = {
    required: true,
    scrollIntoView: false,
    scrollToBottom: '',
  };

  const sectionDivider = <hr className="section-divider" />;

  const { formType } = props;
  const isPvq = isPVQForm(formType);
  return isPvq ? ( // is pvq
    <div>
      <Show when={formType !== formTypes.SF852013}>
        <ConnectedMarital {...subsectionProps} />
        {sectionDivider}
      </Show>
      <People {...subsectionProps} />
      <Show when={formType !== formTypes.SF852013}>
        {sectionDivider}
        <Relatives {...subsectionProps} />
      </Show>
    </div>
  ) : (
    <div>
      <Show when={formType !== formTypes.SF852013}>
        <ConnectedMarital {...subsectionProps} />
        {sectionDivider}
        <ConnectedCohabitants {...subsectionProps} />
        {sectionDivider}
      </Show>
      <People {...subsectionProps} />
      <Show when={formType !== formTypes.SF852013}>
        {sectionDivider}
        <Relatives {...subsectionProps} />
      </Show>
    </div>
  );
};

export default connectSubsection(Review, sectionConfig);
